import { put } from 'redux-saga/effects'

import { appLoadedAction } from '../redux/app'

export function* appInitializedSaga() {
	yield put(appLoadedAction())
}
